<template>
  <div>
    <p class="header">Take a look at this hotel room in Paris.</p>
    <div class="image-holder">
      <img class="image" src="@/assets/main.png" />
      <div class="small-image-holder">
        <img class="image" src="@/assets/side1.png" />
        <img class="image" src="@/assets/side2.png" />
      </div>
    </div>
    <p
      class="header question"
    >Do you think this room costs more than €{{ price }} for a weekend in June?</p>
    <div class="button-holder">
      <bg-button class="button" @click="$router.push({ name: 'stepfive' })" text="Yes"></bg-button>
      <bg-button class="button" @click="$router.push({ name: 'stepfive' })" text="No"></bg-button>
    </div>
  </div>
</template>

<style scoped>
.question {
  text-decoration: underline;
}
.button {
  margin: 20px;
}
.header {
  margin-bottom: 40px;
  font-size: 18px;
}
.paragraph {
  margin-bottom: 10px;
}
.image-holder {
  display: flex;
  justify-content: center;
  margin-bottom: 40px;
  min-height: 341px;
}
.image {
  width: auto;
  margin: 5px;
  max-width: initial;
}
.small-image-holder {
  display: flex;
  flex-direction: column;
}
</style>

<script>
import BgButton from "../components/bg-button";
export default {
  name: "App",
  components: {
    BgButton
  },
  computed: {
    price() {
      return this.$store.state.price;
    }
  }
};
</script>
